import { useEffect } from "react";
import { useForm } from "react-hook-form";
export var useRenameSetModal = function (props) {
    var _a = useForm({
        mode: "onTouched",
        defaultValues: { name: props.currentName },
    }), control = _a.control, handleSubmit = _a.handleSubmit, reset = _a.reset;
    useEffect(function () {
        if (props.opened)
            reset({ name: props.currentName });
    }, [props.opened, props.currentName]);
    var onSubmit = handleSubmit(function (values) {
        props.onRename(values);
    });
    return { control: control, onSubmit: onSubmit };
};
